import { CheckboxField } from '@e3dc-react/shell/Elements/InputFields'
import { Divider, Stack } from '@mui/material'
import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { WallboxCell } from 'src/Libs/e-mobility/charging-sessions/components/WallboxCell'
import { ChargingCardToWallboxFormData } from '../charging-card-to-wallbox-form-data'
import { useTableStyles } from 'src/Libs/e-mobility/shared/styles/table.styles'

interface ChargingCardMobileWallboxCellProps {
  wallboxId: string
  installationId: number
  control: Control<ChargingCardToWallboxFormData>
  ocpiTokenId: string
  shouldDisableButtons: boolean
}

/**
 * Component for displaying one wallbox and checkbox cell for mobile screen for charging card link to wallbox dialog
 */
export const ChargingCardMobileWallboxCell: React.FC<ChargingCardMobileWallboxCellProps> = ({
  wallboxId,
  control,
  ocpiTokenId,
  shouldDisableButtons,
}) => {
  const { classes } = useTableStyles()

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center" paddingY={1}>
        <WallboxCell wallboxId={wallboxId} />
        <Controller
          control={control}
          name={`${ocpiTokenId}.${wallboxId}`}
          render={({ field: { value, onChange } }) => {
            return <CheckboxField value={value} disabled={shouldDisableButtons} onChange={onChange} />
          }}
        />
      </Stack>
      <Divider className={classes.divider} />
    </Stack>
  )
}
